import { configureStore } from '@reduxjs/toolkit';
import counterReducer from '../features/counter/counterSlice';
import dashboardSlice from '../features/dashboard/dashboardSlice';
import reportingSlice from '../features/reporting/reportingSlice';
import teamActivitySlice from '../features/users/team-activity/teamActivitySlice';
import transcriptsSlice from '../features/transcripts/transcriptsSlice';
import OfflineMessagesSlice from '../features/offline-messages/OfflineMessagesSlice';
import settingsSlice from '../features/settings/settingsSlice';
import authSlice from '../features/auth/authSlice';
import chatSlice from '../features/chat/chatSlice';
import vocSlice from '../features/voc/VocSlice';
import adminSlice from '../features/admin/adminSlice';
import paymentSlice from '../features/payment/PaymentSlice';
import agentDashboardSlice from '../features/agent-dashboard/agentDashboardSlice';

import signalRMiddleware from './common/middleware/signalR';
import chatMiddleware from './common/middleware/chat';

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    dashboard: dashboardSlice,
    reporting: reportingSlice,
    teamActivity: teamActivitySlice,
    transcripts: transcriptsSlice,
    offlineMessages: OfflineMessagesSlice,
    settings: settingsSlice,
    auth: authSlice,
    chat: chatSlice,
    voc: vocSlice,
    admin: adminSlice,
    payment: paymentSlice,
    agentDashboard: agentDashboardSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    })
      .concat(signalRMiddleware)
      .concat(chatMiddleware),
});
